/* global angular, imagesLoaded, $ */
angular.module('ua5App')
    .directive('resourceTextphoto', ['$state', '$sce', '$rootScope', '$timeout', function($state, $sce, $rootScope, $timeout) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-textphoto/resource-textphoto.html',
            scope: {
                content: '=',
                contentTitle: '@',
                sectionIndex: '@'
            },
            link: function($scope, element, attrs) {
                // should get an object {body, side, photo}
                $scope.content.body = $sce.trustAsHtml($scope.content.body);
                $scope.content.side = $sce.trustAsHtml($scope.content.side);
                $scope.content.photoBody = $sce.trustAsHtml($scope.content['text-and-photo-body']);

                imagesLoaded(element, function() {
                    $rootScope.$broadcast('resourceComponentPosition');
                });

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});
                    $('[data-scroll-to-section]').click(function(e) {
                        $scope.$emit('scrollToResourceSection', $(this).attr('data-scroll-to-section'));
                        e.preventDefault();
                    });
                });
            }
        };
    }])
;
